module.exports = __webpack_public_path__ + "static/img/performance05.a56c4f28.jpg";